




import { Component, Vue } from 'vue-property-decorator';
import EmployeeList from '@/components/Employee/EmployeeList.vue';

@Component({
  components: {
    EmployeeList,
  },
})
export default class Employees extends Vue {}
